// TSS vite/03 §"Query keys convention".

export const clivageKeys = {
    all:    ['clivages'],
    list:   (filters) => ['clivages', 'list', filters],
    detail: (id)      => ['clivages', 'detail', id],
};
